<template>
    <div ref="overlayWrapper">
        <div class="form-title" style="margin-bottom: 35px; text-transform: unset">
            Quyền riêng tư và Điều khoản sử dụng
        </div>

        <div class="policy">
            <p>
                Để tạo Tài khoản MyVTC, bạn cần phải đồng ý với Điều khoản và Chính
                sách của chúng tôi được quy định chi tiết tại:
            </p>
            <ul>
                <li><a href="javascript:void(0)" @click="openPolicyUrl">Chính sách bảo mật</a></li>
                <li><a href="javascript:void(0)" @click="openTermsOfUseUrl">Điều khoản sử dụng</a></li>
            </ul>
        </div>


        <a href="javascript:void(0)" @click="registerStep3" class="btn-next" style="margin-bottom: 40px">Tôi đồng ý</a>

        <a href="javascript:void(0)" class="btn-back" style="margin-bottom: 100px" @click="backStep">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M6.72488 10.4525L13.6911 17.09C13.8074 17.2008 13.9618 17.2626 14.1224 17.2626C14.283 17.2626 14.4374 17.2008 14.5536 17.09L14.5611 17.0825C14.6177 17.0287 14.6627 16.9641 14.6935 16.8924C14.7242 16.8207 14.7401 16.7436 14.7401 16.6656C14.7401 16.5876 14.7242 16.5104 14.6935 16.4387C14.6627 16.3671 14.6177 16.3024 14.5611 16.2487L8.00113 9.9987L14.5611 3.7512C14.6177 3.69749 14.6627 3.63283 14.6935 3.56116C14.7242 3.4895 14.7401 3.41232 14.7401 3.33433C14.7401 3.25634 14.7242 3.17916 14.6935 3.10749C14.6627 3.03583 14.6177 2.97117 14.5611 2.91745L14.5536 2.90995C14.4374 2.79915 14.283 2.73733 14.1224 2.73733C13.9618 2.73733 13.8074 2.79915 13.6911 2.90995L6.72488 9.54745C6.66362 9.60582 6.61484 9.67603 6.58152 9.75381C6.54819 9.83159 6.53101 9.91533 6.53101 9.99995C6.53101 10.0846 6.54819 10.1683 6.58152 10.2461C6.61484 10.3239 6.66362 10.3941 6.72488 10.4525Z"
                      fill="#0355CE" />
            </svg>
            Quay lại
        </a>
    </div>
</template>
<script>
    import { useRegStore, useAuthStore } from "@/store";
    export default {
        data() {
            const regStore = useRegStore();
            return {
                regStore,
                showWarning: false,
                textWarinng: null,
            };
        },
        methods: {
            backStep() {
                this.$router.push({
                    name: 'regpassword', params: {}
                });
            },
            openPolicyUrl() {
                window.open(`${process.env.VUE_APP_DEFAULT_REDIRECT_URL}/chinh-sach`, '_blank');
            },
            openTermsOfUseUrl() {
                window.open(`${process.env.VUE_APP_DEFAULT_REDIRECT_URL}/dieu-khoan`, '_blank');
            },
            registerStep3() {
                const regStore = useRegStore();
                const authStore = useAuthStore();
                let loader = this.$loading.show({
                    // Optional parameters
                    container: this.$refs.overlayWrapper,
                    canCancel: false,
                });
                regStore.register(3)
                    .then((response) => {
                        loader.hide();
                        if (response.ResponseCode > 0) {
                            if (response.Data.Code != null && response.Data.Code != '') {
                                localStorage.setItem('CUID', JSON.stringify(response.Data.CUID));
                                localStorage.setItem('userInfoMyVTC', JSON.stringify(response.Data.AccountAuthenInfo));
                                authStore.loginSuccess(this.$router, response.Data.Code);
                            }
                            else {
                                this.showWarning = false;
                                this.$swal.fire({
                                    icon: "success",
                                    title: "Đăng ký thành công, chuyển hướng đăng nhập"
                                });
                                
                            authStore.username = regStore.username;
                            authStore.password = regStore.password;
                            authStore.login().then((response) => {

                                this.$router.push({
                                    name: 'username',
                                    params: {},
                                    query: {
                                        service_id: authStore.serviceId,
                                        redirect_url: authStore.redirectUrl,
                                    }
                                });
                            });
                            }
                            return;
                        }
                        var errorDes = this.$t(`register.${response.ResponseCode}`, {}, response.Description);
                        if (response.Errors != null) {
                            if (response.Errors.some(error => error.Field === 'Sign')) {
                                errorDes = this.$t(`register.SignExpired`)
                            }
                        }
                        this.$swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: errorDes,
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            cancelButtonColor: "#d33",
                            cancelButtonText: "Hủy",
                            confirmButtonText: "Đăng ký lại"
                        }).then((result) => {
                            if (result.isConfirmed) {
                                this.$router.push({ name: 'regusername', params: {} })
                            }
                        });
                        return;
                    })
                    .catch((error) => {
                        loader.hide();
                        console.error(error);
                        this.textWarinng = "Hệ thống đang bận vui lòng thử lại sau";
                        this.showWarning = true;
                    });
            },
        },
    };
</script>
<style scoped>
    .policy {
        width: 100%;
        max-width: 400px;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        margin: 0 auto;
        text-align: justify;
        padding-right: 20px;
        margin-bottom: 40px;
    }

        .policy ul li {
            margin-bottom: 5px;
        }

        .policy p {
            margin-bottom: 10px;
        }

        .policy a {
            color: #0355ce !important;
            margin-bottom: 10px;
        }

        .policy a {
            position: relative;
        }

            .policy a::before {
                content: "";
                position: absolute;
                width: 100%;
                height: 1px;
                border-radius: 4px;
                background-color: #0355ce;
                bottom: 5px;
                left: 0;
                transform-origin: right;
                transform: scaleX(0);
                transition: transform 0.3s ease-in-out;
            }

            .policy a:hover::before {
                transform-origin: left;
                transform: scaleX(1);
            }
</style>